import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "types/store";
import { Button } from "aible";
import { OverlayTrigger, Popover } from "react-bootstrap";
import BlueprintSave from "components/ChatGPT/BlueprintSave";
import BlueprintSelector from "components/ChatGPT/BlueprintSelector";
import AddNewAutomaticQuestion from "components/ChatGPT/AddNewAutomaticQuestion";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as globalReducer from "containers/App/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as viewReducer from "containers/View/reducer";
import Select from "react-select";
import { isEnabled } from "utils/featureFlags";
import styles from "./style.module.css";
import { selectOnChangeWrapper } from "utils/select";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
const AutomaticQuestions = () => {
    const dispatch = useDispatch();
    const [isShowAutoApplySettings, setIsShowAutoApplySettings] = useState(false);
    const replayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state));
    const activeReplayPrompts = replayPrompts?.filter((replayPrompt) => replayPrompt?.isHidden !== true && (replayPrompt?.autoAsk === true || replayPrompt?.suggestQuestion === true));
    const modelOptions = useSelector((state) => chatGPTReducer.getModelOptions(state));
    const modelId = useSelector((state) => chatGPTReducer.getModelId(state));
    const selectedModel = modelOptions.find((o) => o.value === modelId);
    const [multiModels, setMultiModels] = useState(selectedModel === undefined ? [] : [selectedModel]);
    useEffect(() => {
        setMultiModels(selectedModel === undefined ? [] : [selectedModel]);
    }, [modelId]);
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const blueprint = useSelector((state) => blueprintReducer.getBlueprint(state, blueprintId));
    return (React.createElement(React.Fragment, null,
        React.createElement(AutoApplySettingsModal, { isShow: isShowAutoApplySettings, setIsShow: setIsShowAutoApplySettings }),
        React.createElement("div", null,
            React.createElement("div", { className: styles.replayPromptsSubTitle }, "I want to automatically ask questions using"),
            React.createElement("div", { style: { padding: "10px" } },
                React.createElement(BlueprintSelector, { menuPlacement: "bottom", style: { width: "285px" } })),
            activeReplayPrompts && activeReplayPrompts?.length > 0 && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.replayPromptsSubTitle }, "Selected Questions"),
                React.createElement("div", { className: styles.replayPromptsHolder },
                    React.createElement("div", { className: styles.selectedPromptsContainer }, activeReplayPrompts.map((p, index) => {
                        return (React.createElement("div", { className: styles.replayPromptsText, key: p?.prompt + "_" + index }, p?.prompt));
                    })))))),
        React.createElement("div", { className: styles.replayPromptsButtons },
            React.createElement(Button, { style: { marginRight: "10px" }, onClick: () => {
                    setIsShowAutoApplySettings(!isShowAutoApplySettings);
                } }, "Find Common Questions / Edit Selection"),
            React.createElement("div", { style: { marginRight: "10px" } },
                React.createElement(AddNewAutomaticQuestion, null))),
        React.createElement("div", { style: { padding: "0px 10px" } },
            React.createElement(BlueprintSave, { blueprintName: blueprint?.name, type: "primary", disabled: activeReplayPrompts?.length <= 0 }, "Save As Auto-Ask Agent Template")),
        isEnabled("auto-compare-multi-models") && (React.createElement("div", { className: styles.autoAskModels },
            React.createElement("div", { className: styles.simpleBold }, "Compare LLM Answers (Optional)"),
            React.createElement("div", { style: { marginTop: "8px", maxWidth: "500px" } }, "Select the LLMs you would like to compare. A CSV will automatically be downloaded once all of the questions have been processed (standard LLM  query token costs apply)"),
            React.createElement("div", { style: { margin: "10px 0px 4px 0px" } }, "Evaluate responses from"),
            React.createElement(Select, { value: multiModels, options: modelOptions, onChange: (val) => Array.isArray(val) && setMultiModels(val), isMulti: true }),
            React.createElement(Button, { style: { marginTop: "10px" }, onClick: () => dispatch(chatGPTReducer.askMultiModels(multiModels, true)), disabled: activeReplayPrompts?.length <= 0 }, "Ask & Download CSV Of Responses")))));
};
const AutoApplySettingsModal = ({ isShow, setIsShow }) => {
    const dispatch = useDispatch();
    const allChats = useSelector((state) => viewReducer.getConvoForReplay(state, false));
    const allMessages = [];
    Object.keys(allChats).forEach((mKey) => {
        allChats[mKey].forEach((msg) => {
            allMessages.push(msg);
        });
    });
    const replayPrompts = useSelector((state) => chatGPTReducer.getReplayPrompts(state));
    const chatsByPrompt = {};
    const blueprintId = useSelector((state) => chatGPTReducer.getBlueprintId(state));
    const [filterBlueprintId, setFilterBlueprintId] = useState(blueprintId);
    //  Connecting filterBlueprintId to blueprintId until use case is tied to automatic questions from modal filter
    useEffect(() => {
        setFilterBlueprintId(blueprintId);
    }, [blueprintId]);
    allMessages
        .filter((msg) => filterBlueprintId === "None" || msg?.analytics?.blueprintId === filterBlueprintId)
        .forEach((msg) => {
        const userPrompt = msg?.userPrompt ?? "";
        if (chatsByPrompt[userPrompt] === undefined) {
            chatsByPrompt[userPrompt] = {
                total: 1,
                cached: msg.isCachedResponse ? 1 : 0
            };
        }
        else {
            chatsByPrompt[userPrompt] = {
                total: chatsByPrompt[userPrompt]?.total + 1,
                cached: chatsByPrompt[userPrompt]?.cached + (msg?.isCachedResponse ? 1 : 0)
            };
        }
    });
    const [hasFetchedAllReports, setHasFetchedAllReports] = useState(false);
    const fetchAllReports = () => dispatch(reportReducer.fetchAllReports(true));
    const chatBlueprints = useSelector((state) => viewReducer.getChatBlueprints(state));
    const chatBlueprintOptions = [
        // { label: "None", value: "None" },
        ...(chatBlueprints
            ? chatBlueprints.map((c) => ({
                label: c.name,
                value: c.id
            }))
            : [])
    ];
    const foundUseCase = chatBlueprintOptions?.find((c) => c.value === filterBlueprintId);
    const isReportsLoading = useSelector((state) => globalReducer.getIsReportsLoading(state));
    const [sortBy, updateSortBy] = useState("PROMPT");
    const filteredBlueprint = chatBlueprints.find((bp) => bp?.id === filterBlueprintId);
    const filteredBlueprintReplayPrompts = filteredBlueprint?.wizard?.chatGPT?.replayPrompts ?? [];
    const oldFilteredReplayPrompts = filteredBlueprintReplayPrompts.filter((prompt) => typeof prompt === "string");
    const newFilteredReplayPrompts = filteredBlueprintReplayPrompts.filter((promptObj) => typeof promptObj !== "string" && promptObj?.prompt !== undefined);
    let typedFilteredBlueprintReplayPrompts = newFilteredReplayPrompts;
    if (oldFilteredReplayPrompts?.length > 0 && newFilteredReplayPrompts?.length <= 0) {
        typedFilteredBlueprintReplayPrompts = oldFilteredReplayPrompts.map((prompt) => {
            const isOldCustomPrompt = filteredBlueprint?.wizard?.chatGPT?.customReplayPrompts?.includes(prompt);
            const isOldHiddenPrompt = filteredBlueprint?.wizard?.chatGPT?.hiddenReplayPrompts?.[prompt] &&
                filteredBlueprint?.wizard?.chatGPT?.hiddenReplayPrompts?.[prompt] === true;
            return {
                prompt: prompt,
                autoAsk: true,
                isCustom: isOldCustomPrompt,
                isHidden: isOldHiddenPrompt
            };
        });
    }
    let allPrompts = [];
    const newCustomReplayPrompts = replayPrompts.filter((promptObj) => promptObj?.isCustom === true && !allPrompts.some((pObj) => pObj?.prompt === promptObj?.prompt));
    if (newCustomReplayPrompts?.length > 0) {
        allPrompts.push(...newCustomReplayPrompts);
    }
    if (sortBy === "POPULARITY") {
        const chatPrompts = Object.keys(chatsByPrompt)
            .sort((a, b) => chatsByPrompt[b]?.total - chatsByPrompt[a]?.total)
            .map((prompt) => ({
            prompt: prompt
        }));
        allPrompts = [...chatPrompts];
        if (filteredBlueprint) {
            const savedReplayPrompts = typedFilteredBlueprintReplayPrompts.filter((promptObj) => {
                if (promptObj?.prompt !== undefined) {
                    return false;
                }
                return !allPrompts.some((pObj) => pObj?.prompt === promptObj?.prompt);
            });
            if (savedReplayPrompts?.length > 0) {
                allPrompts.push(...savedReplayPrompts);
            }
        }
    }
    else {
        allPrompts = [];
        replayPrompts.forEach((p) => {
            if (!allPrompts.some((promptObj) => promptObj?.prompt === p?.prompt)) {
                allPrompts.push(p);
            }
        });
        typedFilteredBlueprintReplayPrompts.forEach((p) => {
            if (!allPrompts.some((promptObj) => promptObj?.prompt === p?.prompt)) {
                allPrompts.push(p);
            }
        });
        Object.keys(chatsByPrompt)
            .map((prompt) => ({
            prompt: prompt
        }))
            .forEach((p) => {
            if (!allPrompts.some((promptObj) => promptObj?.prompt === p?.prompt)) {
                allPrompts.push(p);
            }
        });
    }
    const filteredAllPrompts = allPrompts?.filter((allPrompt) => allPrompt?.isHidden !== true);
    const filteredReplayPrompts = replayPrompts?.filter((replayPrompt) => replayPrompt?.isHidden !== true);
    const allPromptsSelected = filteredAllPrompts?.length === filteredReplayPrompts?.length &&
        filteredReplayPrompts.every((prompt) => prompt?.autoAsk === true);
    const allPromptsSuggested = filteredAllPrompts?.length === filteredReplayPrompts?.length &&
        filteredReplayPrompts.every((prompt) => prompt?.suggestQuestion === true);
    const hasActivePrompts = filteredReplayPrompts.some((prompt) => prompt?.autoAsk === true || prompt?.suggestQuestion === true);
    console.log("Filtered all prompts: ", filteredAllPrompts);
    // I hate everything about this. :(
    const handleDelete = (userPrompt) => {
        const foundPrompt = allPrompts.find((promptObj) => String(promptObj?.prompt).trim() === String(userPrompt).trim());
        const foundIndex = allPrompts.findIndex((promptObj) => String(promptObj?.prompt).trim() === String(userPrompt).trim());
        if (foundPrompt === undefined || foundIndex === -1) {
            return;
        }
        const retPrompt = {
            ...foundPrompt,
            isHidden: true
        };
        const retReplayPrompts = [...replayPrompts];
        retReplayPrompts.splice(foundIndex, 1, retPrompt);
        dispatch(chatGPTReducer.updateReplayPrompts(retReplayPrompts));
    };
    return (React.createElement(Dialog, { open: isShow, onOpenChange: () => setIsShow(false) },
        React.createElement(DialogContent, { size: "xl" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Find Questions To Ask Automatically")),
            React.createElement("div", { className: styles.autoApplySettingsBody },
                React.createElement("div", { className: styles.autoApplySelect },
                    React.createElement("div", { className: styles.autoApplyTitle }, "Select Chat Messages"),
                    React.createElement("div", { className: styles.automaticQuestionsTable },
                        React.createElement("div", { className: styles.chatMessageHeaderRow },
                            React.createElement("div", { className: styles.chatMessageHeaderColumn, style: { minWidth: "10%", width: "10%", flexGrow: "1" } },
                                "Saved Question",
                                filteredAllPrompts?.length > 0 && (React.createElement("div", { className: styles.selectAllLinkWrapper },
                                    React.createElement("a", { className: styles.selectAllLink, onClick: () => {
                                            if (allPromptsSelected) {
                                                console.log(allPromptsSelected, "Deselecting all prompts.");
                                                const retPrompts = allPrompts.map((prompt) => {
                                                    return {
                                                        ...prompt,
                                                        autoAsk: false
                                                    };
                                                });
                                                dispatch(chatGPTReducer.updateReplayPrompts(retPrompts));
                                            }
                                            else {
                                                console.log(allPromptsSelected, "Selecting all prompts.");
                                                const retPrompts = filteredAllPrompts.map((prompt) => {
                                                    return {
                                                        ...prompt,
                                                        autoAsk: true
                                                    };
                                                });
                                                dispatch(chatGPTReducer.updateReplayPrompts(retPrompts));
                                            }
                                        } }, allPromptsSelected ? "Deselect All" : "Select All")))),
                            isEnabled("chat-suggest-saved-questions") && (React.createElement("div", { className: styles.chatMessageHeaderColumn, style: { minWidth: "10%", width: "10%" } },
                                "Suggested Question",
                                filteredAllPrompts?.length > 0 && (React.createElement("div", { className: styles.selectAllLinkWrapper },
                                    React.createElement("a", { className: styles.selectAllLink, onClick: () => {
                                            if (allPromptsSuggested) {
                                                console.log(allPromptsSuggested, "Deselecting all suggested.");
                                                const retPrompts = allPrompts.map((prompt) => {
                                                    return {
                                                        ...prompt,
                                                        suggestQuestion: false
                                                    };
                                                });
                                                dispatch(chatGPTReducer.updateReplayPrompts(retPrompts));
                                            }
                                            else {
                                                console.log(allPromptsSuggested, "Selecting all suggested.");
                                                const retPrompts = filteredAllPrompts.map((prompt) => {
                                                    return {
                                                        ...prompt,
                                                        suggestQuestion: true
                                                    };
                                                });
                                                dispatch(chatGPTReducer.updateReplayPrompts(retPrompts));
                                            }
                                        } }, allPromptsSuggested ? "Deselect All" : "Select All"))))),
                            React.createElement("div", { className: styles.chatMessageHeaderColumn, style: {
                                    minWidth: "60%",
                                    width: "60%",
                                    cursor: "pointer",
                                    fontWeight: sortBy === "PROMPT" ? "bold" : "normal"
                                }, onClick: () => updateSortBy("PROMPT") },
                                React.createElement("span", { style: { marginLeft: "-4px" } }, "Prompt")),
                            React.createElement("div", { className: styles.chatMessageHeaderColumn, style: {
                                    minWidth: "10%",
                                    width: "10%",
                                    cursor: "pointer",
                                    fontWeight: sortBy === "POPULARITY" ? "bold" : "normal"
                                }, onClick: () => updateSortBy("POPULARITY") }, "Popularity"),
                            React.createElement("div", { className: styles.chatMessageHeaderColumn, style: { minWidth: "10%", width: "10%" } }, " ")),
                        filteredAllPrompts?.map((allPrompt, i) => {
                            const foundQuestion = replayPrompts.find((p) => p?.prompt === allPrompt?.prompt);
                            const isIncludedAutoAsk = foundQuestion !== undefined && foundQuestion?.autoAsk === true;
                            const isIncludedSuggested = foundQuestion !== undefined && foundQuestion?.suggestQuestion === true;
                            return (React.createElement("div", { key: i, className: styles.chatMessageRow, style: i % 2 === 0 ? { background: "white" } : { background: "rgb(247, 245, 250)" } },
                                React.createElement("div", { className: styles.chatMessageColumn, style: {
                                        minWidth: "10%",
                                        width: "10%",
                                        textAlign: "center",
                                        flexGrow: "1"
                                    } },
                                    React.createElement("input", { type: "checkbox", onClick: () => {
                                            const foundReplayPrompt = filteredReplayPrompts.find((p) => p?.prompt === allPrompt?.prompt);
                                            if (foundReplayPrompt) {
                                                const retReplayPrompts = filteredReplayPrompts.map((p) => {
                                                    if (p?.prompt === allPrompt?.prompt) {
                                                        return {
                                                            ...p,
                                                            autoAsk: !isIncludedAutoAsk
                                                        };
                                                    }
                                                    return p;
                                                });
                                                return dispatch(chatGPTReducer.updateReplayPrompts(retReplayPrompts));
                                            }
                                            const newPrompt = {
                                                ...allPrompt,
                                                autoAsk: !isIncludedAutoAsk
                                            };
                                            return dispatch(chatGPTReducer.updateReplayPrompts([...replayPrompts, newPrompt]));
                                        }, checked: isIncludedAutoAsk })),
                                isEnabled("chat-suggest-saved-questions") && (React.createElement("div", { className: styles.chatMessageColumn, style: {
                                        minWidth: "10%",
                                        width: "10%",
                                        textAlign: "center"
                                    } },
                                    React.createElement("input", { type: "checkbox", onClick: () => {
                                            const foundReplayPrompt = filteredReplayPrompts.find((p) => p?.prompt === allPrompt?.prompt);
                                            if (foundReplayPrompt) {
                                                const retReplayPrompts = filteredReplayPrompts.map((p) => {
                                                    if (p?.prompt === allPrompt?.prompt) {
                                                        return {
                                                            ...p,
                                                            suggestQuestion: !isIncludedSuggested
                                                        };
                                                    }
                                                    return p;
                                                });
                                                return dispatch(chatGPTReducer.updateReplayPrompts(retReplayPrompts));
                                            }
                                            const newPrompt = {
                                                ...allPrompt,
                                                suggestQuestion: !isIncludedSuggested
                                            };
                                            return dispatch(chatGPTReducer.updateReplayPrompts([...replayPrompts, newPrompt]));
                                        }, checked: isIncludedSuggested }))),
                                React.createElement("div", { className: styles.chatMessageColumn, style: {
                                        minWidth: "60%",
                                        width: "60%",
                                        textAlign: "left"
                                    } }, allPrompt?.prompt),
                                React.createElement("div", { className: styles.chatMessageColumn, style: { minWidth: "10%", width: "10%" } }, chatsByPrompt[allPrompt?.prompt]?.total ?? 1),
                                React.createElement("div", { className: styles.chatMessageColumn + " " + styles.chatMessageColumnActions, style: { minWidth: "10%", width: "10%" } },
                                    React.createElement(Button, { isSmall: true, style: { padding: "2px 4px" }, onClick: () => handleDelete(allPrompt?.prompt) }, "Delete"))));
                        }),
                        React.createElement("div", { style: { marginTop: "10px" } },
                            React.createElement(AddNewAutomaticQuestion, null)),
                        !hasFetchedAllReports ? (React.createElement("div", { className: styles.loadAllChats },
                            React.createElement(Button, { onClick: () => {
                                    fetchAllReports();
                                    setHasFetchedAllReports(true);
                                } }, "Load All Chats"))) : isReportsLoading ? (React.createElement("div", { className: styles.autoApplyLoading },
                            "Scanning For Common Questions",
                            React.createElement(LoadingIndicator, { style: { margin: "0px", marginLeft: "-6px" } }))) : (React.createElement("div", null))),
                    React.createElement("div", { className: styles.autoApplyFilters },
                        React.createElement(OverlayTrigger, { placement: "right", trigger: hasActivePrompts ? ["hover"] : [], overlay: React.createElement(Popover, { id: "popover-positioned-right" },
                                React.createElement("div", null, "Deselect all questions if you would like to switch agent templates.")) },
                            React.createElement("div", { className: styles.autoApplyF },
                                React.createElement("div", { style: { fontWeight: "bold" } }, "Filter By Agent Template"),
                                React.createElement(Select, { options: chatBlueprintOptions, value: foundUseCase, onChange: selectOnChangeWrapper((val) => {
                                        setFilterBlueprintId(val);
                                        dispatch(chatGPTReducer.selectBlueprint(val));
                                    }), menuPlacement: "top", isDisabled: hasActivePrompts })))))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { onClick: () => setIsShow(false) }, "Close")))));
};
export default AutomaticQuestions;
